var currentPosition = {xPosition : 0, yPosition : 0};
var currentSize = {widthWindow: 566,heightWindow: 326, minTableWidth : 566};
var parametersCell = null;
var tableOptions = null;
var totalSelected = 5;
export function setTotalSelected(tSelected){
  totalSelected = tSelected;
}
export function getTotalSelected(){
  return totalSelected;
}
export function setCurrentPosition(position){
  currentPosition.xPosition += position.xPosition;
  currentPosition.yPosition += position.yPosition;
}
export function getCurrentPosition(){
  return currentPosition;
}
export function setCurrentSize(cSize){
  currentSize = cSize;
}
export function getCurrentSize(){
  return currentSize;
}
export function setParameters(parameters){
  parametersCell = parameters;
}
export function getParameters(){
  return parametersCell;
}
export function setTableOptions(tOptions){
  tableOptions = tOptions;
}
export function getTableOptions(){
  return tableOptions;
}



// WEBPACK FOOTER //
// ./src/js/Singletons/RecordCallSingleton.js